import React, { ReactElement, ReactNode } from "react";
// import Slider from "react-slick";
import Slider, { Settings } from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronLeft,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./CarouselModal.module.scss";

interface CarouselModalProps {
  images: string[];
  currentImage: number;
  closeModal: () => void;
}

// 1. Оборачиваем оригинальный Slider
const SliderWrapper: React.FC<Settings & { children: ReactNode }> = ({
  children,
  ...settings
}) => {
  return <Slider {...settings}>{children}</Slider>;
};

export default SliderWrapper;

function NextArrow(props: any) {
  const { className, style, onClick } = props;
  const onArrowClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <FontAwesomeIcon
      icon={faChevronRight}
      className={className}
      style={{
        ...style,
        color: "#fefefe",
        height: 65,
        padding: "5px",
        right: "-5%",
        top: "50%",
        transform: "translateY(-50%)",
      }}
      onClick={onArrowClick}
    />
  );
}

function PrevArrow(props: any) {
  const { className, style, onClick } = props;
  const onArrowClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    e.stopPropagation();
    onClick();
  };
  return (
    <FontAwesomeIcon
      icon={faChevronLeft}
      className={className}
      style={{
        ...style,
        color: "#fefefe",
        height: 65,
        padding: "5px",
        left: "-5%",
        top: "50%",
        transform: "translateY(-50%)",
      }}
      onClick={onArrowClick}
    />
  );
}

const renderDotsOutsideSlider = (dots: ReactElement) => {
  return (
    <div className={styles.customDotsContainer}>
      <ul className={styles.customDots}>{dots}</ul>
    </div>
  );
};

export function CarouselModal({
  images,
  currentImage,
  closeModal,
}: CarouselModalProps) {
  const settings = {
    dots: true,
    appendDots: renderDotsOutsideSlider,
    initialSlide: currentImage,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: true,

    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const handleClose = (event: React.MouseEvent<HTMLElement>) => {
    const clickedElement = event.target as HTMLElement;
    const isImageClicked = clickedElement.tagName === "IMG";
    const isButtonClicked = clickedElement.tagName === "SVG";
    const isDotClicked = clickedElement.parentElement?.tagName === "LI";
    if (!isImageClicked && !isButtonClicked && !isDotClicked) {
      closeModal();
    }
  };

  return (
    <>
      <div className={styles.carouselModal} onClick={handleClose}>
        <button className={styles.closeBtn}>
          <FontAwesomeIcon
            size="2xl"
            icon={faXmark}
            style={{ color: "#fefefe" }}
          />
        </button>
        <div className={styles.carousel}>
          <div className={styles.carouselContainer}>
            <SliderWrapper {...settings}>
              {images
                .filter((v) => v)
                .map((image) => (
                  <div className={styles.imageWrap} key={image}>
                    <img src={image} alt={image} className={styles.image} />
                  </div>
                ))}
            </SliderWrapper>
          </div>
        </div>
      </div>
    </>
  );
}
